import { ActionTree, MutationTree, GetterTree } from 'vuex'
import axios, { AxiosError } from 'axios'

import config from '../config'

export interface State {
    error: string
}

const state: State = {
    error: '',
}

export const mutations: MutationTree<State> = {
    setError(state, error: string) {
        state.error = error
    },
    clearError(state) {
        state.error = ''
    },
}

export const actions: ActionTree<State, any> = {
    request(context, { method, path, params, data }) {
        const jwt = context.rootState.auth.session.jwt
        const headers = {
            Authorization: `Bearer ${jwt}`,
        }
        return axios.request({
            method,
            url: `${config.SERVER_URL}v1.0/${path}/`,
            headers,
            params,
            data,
        })
    },
    get (context, options) {
        return context.dispatch('request', {
            ...options,
            method: 'get',
        })
    },
    post (context, options) {
        return context.dispatch('request', {
            ...options,
            method: 'post',
        })
    },
    patch (context, options) {
        return context.dispatch('request', {
            ...options,
            method: 'patch',
        })
    },
    delete (context, options) {
        return context.dispatch('request', {
            ...options,
            method: 'delete',
        })
    },
}

export const api = {
    namespaced: true,
    state,
    mutations,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/api.ts